import { useRef } from 'react';

export const useRefValue = <T>(value: T) => {
  const valueRef = useRef<T>(value);
  valueRef.current = value;

  return valueRef;
};
